/* eslint-disable @nx/enforce-module-boundaries */
import { generate, sessionKeyStorage } from '@credit-web/shared/browser-utils'
import { type AxiosRequestConfig } from 'axios'
import { isomorphicCookies } from 'shared/storage'

export const bffHeadersInterceptor = (data: AxiosRequestConfig) => {
  const { accountId } = isomorphicCookies.getAll()

  const bffHeaders = {
    'Saga-Key': generate.sagaKey(),
    'Session-Key': sessionKeyStorage.get(),
    'Account-Id': accountId
  }
  return { ...data, headers: { ...data.headers, ...bffHeaders } }
}
